module.exports = __webpack_public_path__ + "img/icon-arrow-right.be882cd6.svg";